<template>
    <page>
        <div class="shadow-25 column items-center justify-center central-content">
            <v-header :title="$t('export file')" icon="cloud download"></v-header>
            <card width="400px" style="margin: 0 auto;">

                <form class="q-pt-xs gutter-xs row full-width" method="post" target="_blank"
                :action="`${config.appUrl}/call-center/order/export`" @submit="back">
                    <input type="hidden" name="start_date" :value="form.start_date">
                    <input type="hidden" name="end_date" :value="form.end_date">

                    <v-datetime path="start_date"
                                v-model="form.start_date"
                                :label="$t('start date')"
                                format-data="YYYY-MM-DD"
                                format="DD-MM-YYYY"
                                :form="form"
                                class="col-md-6 col-xs-12">
                    </v-datetime>

                    <v-datetime path="end_date"
                                v-model="form.end_date"
                                :label="$t('end date')"
                                format-data="YYYY-MM-DD"
                                format="DD-MM-YYYY"
                                :form="form"
                                class="col-md-6 col-xs-12">
                    </v-datetime>

                    <!-- Submit Button -->
                    <div class="row justify-center col-12 q-mt-md">
                        <v-button outline
                                  :label="$t('download')"
                                  icon="cloud download"
                                  color="highlight"
                                  class="no-shadow uppercase q-btn-iqos"
                                  type="submit">
                        </v-button>
                    </div>

                </form>

            </card>
        </div>
    </page>
</template>

<script>
    import moment from 'moment'
    export default {
        middleware: 'auth',

        metaInfo() {
            return {title: this.$T('export file')}
        },

        data() {
            return {
                config,
                form: {
                    start_date: moment().subtract(1, 'month').format('YYYY-MM-DD'),
                    end_date: moment().format('YYYY-MM-DD'),
                }
            }
        },

        methods: {
            back() {
                this.$router.push({name: 'home'})
            }
        }
    }
</script>


// WEBPACK FOOTER //
// resources/assets/js/pages/call-center/order/export.vue